export default {
  index: {
    title: '首頁'
  },

  about: '關於本會',

  introduction: {
    title: '本會介紹',
    detail: {
      history: { title: '緣起' },
      'current-situation': { title: '會務概況' }
    }
  },

  founder: {
    title: '淨空老和尚',
  },

  chairman: {
    title: '本會董事長',
  },

  library: {
    title: '華藏講堂圖書館',
  },

  contact: {
    title: '聯絡我們',
    detail: {
      heading: {
        contacts: '聯絡地址及代表號'
      },
      label: {
        name: '名稱',
        address: '地址',
        telephone: '電話',
        email: '電子郵件',
        fax: '傳真',
        'fax-hotline-for-dharma-application': '傳真(法寶流通專線)',
        'tax-id-number': '統一編號',
        url: '網址'
      },
      value: {
        name: '財團法人佛陀教育基金會',
        address: '(100022) 臺北市中正區杭州南路一段55號3樓',
        telephone: '02-2395-1198',
        email: 'budaedu@budaedu.org',
        fax: '02-2391-3415',
        'fax-hotline-for-dharma-application': '02-2396-5959',
        'tax-id-number': '21102881',
        url: 'https://www.budaedu.org'
      }
    }
  },

  donation: {
    title: '護持捐款',
    heading: {
      'credit-card': '信用卡捐款',
      'wire-transfer': {
        domestic: '國內電匯',
        international: '國際電匯'
      }
    }
  },

  traffic: {
    title: '交通方式',
    text: {
      name: '財團法人佛陀教育基金會',
      address: '(100022) 臺北市中正區杭州南路一段55號'
    },
    button: {
      'google-map': { label: '開啟 Google 地圖導航' }
    }
  },

  recruitment: {
    title: '人才及志工招募',
  },

  announcement: '會務公告',

  bulletin: {
    title: '最新消息'
  },

  'course-cancel-bulletin': {
    title: '停課公告',
    table: {
      header: {
        date: '日期',
        course: '課程',
        lecturer: '講者'
      }
    }
  },

  sidelight: {
    title: '會務集錦',
    list: {
      'search-bar': {
        'category-selector': { hint: '選擇分類' },
        'year-selector': { hint: '選擇年份' },
        'search-button': { label: '搜尋' }
      },
      button: {
        'more-info': { label: '更多資訊' }
      }
    },
    detail: {
      heading: {
        'photos-compressed-file': '照片壓縮檔',
        photos: '照片',
        videos: '影片'
      },
      'instruction-text': {
        'click-icon-to-download-file': '點擊圖示可下載檔案',
        'click-thumbnail-to-enlarge-photo': '點擊小圖可放大照片'
      }
    }
  },

  weekly: {
    title: '佛陀教育電子報',
    list: {
      'search-bar': {
        'year-selector': {
          hint: '年份',
          option: { label: '{year}年' }
        },
        'month-selector': {
          hint: '月份',
          option: { label: '{month}月' }
        },
        'search-button': { label: '搜尋' }
      },
      button: {
        'subscribe-or-unsubscribe': { label: '訂閱 / 退訂電子報' },
        read: { label: '閱讀或下載' }
      }
    }
  },

  monthly: {
    title: '佛陀教育月刊',
    list: {
      'search-bar': {
        'year-selector': {
          hint: '年份',
          option: { label: '{year}年' }
        },
        'month-selector': {
          hint: '月份',
          option: { label: '{month}月' }
        },
        'search-button': { label: '搜尋' }
      },
      button: {
        read: { label: '閱讀或下載' }
      }
    }
  },

  activitie: '課程活動',

  course: {
    title: '佛法課程',
    list: {
      latest: {
        title: '最新課程',
        button: {
          introduction: { label: '簡介' }
        }
      },
      all: { title: '課程總表' },
      today: { title: '今日課程' },
      review: { title: '課程回顧' },
      table: {
        header: {
          time: '時間',
          course: '課程',
          lecturer: '講者',
          place: '地點',
          'start-date': '開課日期',
          'end-date': '圓滿日期',
          livestream: '線上直播',
          series: '影音檔',
          remark: '備註'
        }
      },
      button: {
        livestream: { label: '觀看' },
        'video-or-audio': { label: '點播或下載' }
      },
      message: {
        'have-not-started-yet': '尚未開課',
        none: '無'
      }
    },
    detail: {
      title: '課程介紹',
      button: {
        'view-more': { label: '瀏覽更多課程' }
      },
      label: {
        name: '課程名稱',
        time: '上課時間',
        place: '上課地點',
        lecturer: '授課老師',
        introduction: '課程簡介',
        livestream: '線上直播'
      },
      message: {
        'has-not-started-yet': '課程尚未開始',
        'has-ended': '課程已圓滿',
        none: '無'
      }
    }
  },

  lecturer: {
    detail: {
      title: '講者介紹',
      label: {
        name: '講師名稱',
        introduction: '講師簡介'
      }
    }
  },

  academy: {
    title: '假日佛學院',
    detail: {
      'cohort-selector': { hint: '請選擇' },
      'course-livestream': {
        title: '課程直播',
        table: {
          header: {
            course: '課程',
            livestream: '直播'
          }
        },
        button: {
          livestream: { label: '觀看' },
        }
      },
      'cource-series': {
        title: '課堂影音',
        'department-selector': { hint: '選擇班別' },
        hint: '請先選擇班別',
        table: {
          header: {
            course: '課程',
            series: '影音'
          }
        },
        button: {
          'stream-or-download': { label: '點播或下載' }
        }
      },
      'admission-brochure': {
        title: '招生簡章',
        label: {
          objective: '教學宗旨目標',
          'teaching-methods': '教學方式',
          'school-system': '課程學制與選課規定',
          'start-date': '開課日期',
          location: '上課地點',
          'register-ways': '報名',
          'register-fee': '費用',
          register: { label: '線上報名' }
        },
        button: {
          register: { label: '線上報名' }
        },
        message: {
          free: '免費'
        },
        'department-list': {
          title: '課程分班、師資及授課時間',
          description: '設 {class_count} 班、 {sect_count} 宗，合計 {total_count} 班。',
          label: {
            lecturer: '班導師',
            date: '日期',
            time: '時間',
            livestream: '直播',
            audiovisual: '錄影'
          },
          button: {
            introduction: '簡介'
          }
        }
      }
    }
  },

  department: {
    detail: {
      label: {
        lecturer: '班導師',
        'lecturer-introduction': '班導師簡介',
        time: '上課時間',
        'livestream-and-recording': '直播與錄影',
        livestream: '直播',
        recording: '錄影',
        'course-plan': '課程計畫'
      }
    }
  },

  'hwadzan-garden': {
    title: '華藏教學園區',
    detail: {
      title: '簡介',
      label: {
        address: '地址',
        'tel-and-fax': '電話/傳真',
        rule: '園區管理辦法',
        'borrowing-application-form': '借用申請表',
        map: '園區地圖'
      },
      value: {
        address: '地址：新北市深坑區阿柔里 5 鄰大崙尾 9 號',
        'tel-and-fax': '電話：(02) 2662-9168；傳真：2664-9241'
      },
      link: {
        'rule-web-ver': '網頁版',
        'rule-download-ver': '檔案下載',
        'borrowing-application-form': '檔案下載',
        'illustrated-driving-map': '開車路線示意圖'
      },
      message: {
        'online-ver': '線上瀏覽',
        'doc-format': 'doc 格式'
      },
      'photo-list': {
        title: '園區照片',
        'buddha-hall': { title: '佛殿' },
        'plaza': { title: '廣場' },
        'corridor': { title: '迴廊' },
        'outdoor': { title: '戶外' },
        'dining-hall': { title: '齋堂' },
        'admin-center': { title: '行政中心' },
        'dormitory': { title: '寮房' }
      },
      // 園區照片 alt
      // 'photo-alt': {
      //   'buddha-hall-1': '華藏教學園區 佛殿照片1',
      //   'buddha-hall-2': '華藏教學園區 佛殿照片2',
      //   'buddha-hall-3': '華藏教學園區 佛殿照片3',
      //   'plaza-1': '華藏教學園區 廣場照片1',
      //   'plaza-2': '華藏教學園區 廣場照片2',
      //   'corridor-1': '華藏教學園區 迴廊照片1',
      //   'corridor-2': '華藏教學園區 迴廊照片2',
      //   'outdoor-1': '華藏教學園區 戶外照片1',
      //   'outdoor-2': '華藏教學園區 戶外照片2',
      //   'dining-hall-1': '華藏教學園區 齋堂照片',
      //   'admin-center-1': '華藏教學園區 行政中心照片',
      //   'dormitory-1': '華藏教學園區 寮房照片'
      // }
    }
  },

  event: {
    title: '華藏教學園區',
    list: {
      latest: {
        title: '最新活動',
        message: {
          'no-event-this-year': '本年度 ({year} 年) 無活動'
        }
      },
      review: {
        title: '活動回顧',
        modal: {
          'sidelight': { title: '活動集錦' }
        },
        message: {
          'no-event-this-year': '本年度 ({year} 年) 無活動紀錄'
        }
      },
      'year-selector': {
        option: { label: '{year}年' }
      },
      table: {
        header: {
          'start-date': '開始日期',
          'end-date': '圓滿日期',
          name: '名稱',
          organizer: '主辦單位',
          leader: '主法法師或指導老師',
          registration: '報名',
          contact: '聯絡方式',
          livestream: '提供直播',
          sidelight: '活動集錦'
        }
      },
      button: {
        introduction: { label: '簡章' },
        registration: { label: '報名表' },
        register: { label: '報名' },
        livestream: { label: '觀看' },
        sidelight: { label: '瀏覽' },
        'browse-video-or-audio': { label: '活動影音瀏覽' }
      },
      message: {
        'please-refer-contact': '請參考聯絡方式',
        'event-ended': '活動已圓滿',
        none: '無'
      }
    },
    detail: {
      title: '活動介紹',
      registration: {
        title: '活動報名',
        label: {
          'target-audience': '活動對象',
          'leader-intro': '指導者介紹',
          content: '活動內容',
          'registration-date': '報名日期',
          'registration-method': '報名方式',
          'registration-fee': '參加費用',
          quota: '參加名額',
          'shuttle-info': '搭乘專車時間地點',
          'self-check-in-info': '自行報到時間地點',
          note: '注意事項或備註'
        },
        button: {
          'registration-form-download': { label: '報名表下載' },
          'register': { label: '報名' }
        }
      },
      livestream: {
        title: '活動直播',
        schedule: {
          title: '直播時程表',
          'date-selector': { label: '活動日期' }
        }
      },
      schedule: {
        table: {
          header: {
            date: '日期',
            'start-time': '開始時間',
            'end-time': '結束時間',
            name: '名稱',
            leader: '主法或指導',
            livestream: '線上直播'
          }
        },
        button: {
          livestream: { label: '觀看' },
        },
        message: {
          none: '無'
        }
      },
      handout: {
        list: {
          title: '講義電子檔下載'
        }
      },
      label: {
        name: '名稱',
        'start-date': '開始日期',
        'end-date': '圓滿日期',
        venue: '地點'
      },
      button: {
        'view-more': { label: '瀏覽更多活動' }
      }
    }
  },

  resource: '法寶資源',

  book: {
    title: '經書法寶',
    list: {
      application: {
        title: '申請',
        link: {
          'master-list-download': '總表下載'
        }
      },
      download: { title: '下載' },
      search: {
        title: '經書搜尋',
        'search-bar': {
          label: '經書查詢',
          'keyword-inputor': { hint: '請輸入關鍵字' },
          'search-button': { label: '搜尋' }
        },
        message: {
          'no-result': '搜尋不到符合關鍵字的結果'
        }
      },
      label: {
        'selected-language': '目前選擇'
      },
      modal: {
        'next-page-notice': {
          title: '提示',
          message: '有更多頁面，請繼續瀏覽'
        }
      }
    },
    detail: {
      title: '經書介紹',
      list: {
        efile: {
          heading: '經書電子檔'
        }
      },
      button: {
        'view-more': { label: '瀏覽更多經書' }
      }
    },
    'efile-list': {
      title: '經書電子檔',
      table: {
        header: {
          format: '格式',
          name: '名稱',
          size: '大小',
          date: '日期',
          pages: '頁數'
        }
      },
      label: {
        'upload-date': '上傳日期',
        'updated-date': '更新日期'
      },
      message: {
        'no-efile': '無電子檔可下載'
      }
    },
    button: {
      'size-cm-conversion': { label: '開數對照' },
      introduction: { label: '簡介' },
      application: {
        label: {
          'in-stock': '書籍申請',
          'out-of-stock': '無庫存'
        }
      },
      download: { label: '電子檔下載' }
    }
  },

  'lendable-book': {
    title: '圖書館藏書目',
    list: {
      label: {
        'registration-number': '登錄號',
        'call-number': '分類號'
      },
      button: {
        introduction: { label: '詳細資料' }
      },
      modal: {
        'library-collection-inquiry-notice': {
          title: '圖書館藏查詢提示',
          message: {
            'cannot-provide-borrow-and-return-services': '本系統僅限查詢本會既有之圖書館藏書籍，無法提供「線上借還」服務。',
            'borrow-in-person': '欲借閱書籍，請親至本會三樓服務台洽詢辦理。',
            'includes-books-that-are-borrowed-but-not-returned-and-lost': '由於採開架式借書型式，館藏目錄包含有「外借但未歸還」及「遺失」書籍等。'
          }
        }
      }
    },
    detail: {
      title: '圖書館藏詳細資料',
      table: {
        header: {
          'registration-number': '登錄號',
          'call-number': '分類號',
          publisher: '出版者',
          'publication-year': '出版年',
          edition: '版次',
          'material-type': '資料類型',
          binding: '裝訂',
          'collection-location': '館藏地',
          'shelf-number': '書架號',
          isbn: 'ISBN'
        }
      }
    },
    // 新增搜尋列佔位文字
    'search-bar': {
      placeholder: '請輸入關鍵字'
    },
  },

  series: {
    title: '影音與光碟',
    list: {
      title: '影音',
      latest: {
        title: '最新影音',
        button: {
          introduction: { label: '講題介紹' }
        }
      },
      'recently-updated': {
        title: '近期更新',
        ongoing: {
          title: '開課中(持續更新)',
          button: {
            'watch-latest-episode': { label: '觀看最新一集' }
          },
          label: { 'updated-date': '更新日期' }
        },
        'recently-added': {
          title: '新增講題',
          button: {
            'watch-first-episode': { label: '觀看第一集' }
          },
          label: { 'added-date': '新增日期' }
        },
        updated: {
          title: '集數更新',
          button: {
            'watch-latest-episode': { label: '觀看最新一集' }
          },
          label: { 'updated-date': '更新日期' }
        }
      },
      classified: {
        title: '影音分類',
        'category-selector': { hint: '選擇分類項目' },
        label: { 'selected-category': '目前選擇' }
      },
      search: {
        title: '影音搜尋',
        'search-bar': {
          'keyword-inputor': { hint: '請輸入關鍵字' },
          'search-button': { label: '影音搜尋' }
        },
        message: {
          'no-result': '搜尋不到符合關鍵字的結果'
        }
      },
      button: {
        introduction: { label: '講題介紹' }
      }
    },
    detail: {
      title: '講題介紹',
      label: {
        lecturer: '主講者',
        'start-date': '開課日期'
      },
      list: {
        handout: {
          heading: '講義下載',
          label: { 'updated-date': '更新日期' },
          button: {
            download: { label: '下載' }
          }
        },
        episode: {
          heading: '影音觀看與下載',
          label: { 'updated-date': '更新日期' },
          button: {
            stream: { label: '線上觀看' },
            download: { label: '影音檔下載' }
          }
        }
      }
    },
    'livestream-list': {
      title: '直播',
      today: { title: '今日直播' },
      all: { title: '直播總表' },
      table: {
        header: {
          time: '時間',
          course: '課程',
          lecturer: '講者',
          'start-date': '開課日期',
          livestream: '線上直播',
          remark: '備註'
        }
      },
      button: {
        livestream: { label: '觀看' }
      },
      message: {
        'have-not-started-yet': '尚未開課'
      }
    },
    'episode-efile-list': {
      heading: {
        video: '影片檔',
        audio: '音訊檔'
      },
      message: {
        'video-file-is-in-rm-format': '本集影片檔為 rm 格式，<br>若您無法播放該檔案，您可 <a class="btn btn-outline-primary  btn-sm" href="https://www.real.com/" target="_blank">下載 RealPlayer</a> 來播放。'
      }
    }
  },

  picture: {
    title: '佛像與佛卡',
    list: {
      application: {
        title: '申請',
        link: {
          'master-list-download': '總表下載'
        }
      },
      download: { title: '下載' },
      search: {
        title: '佛像搜尋',
        'search-bar': {
          label: '佛像查詢',
          'keyword-inputor': { hint: '請輸入關鍵字' },
          'search-button': { label: '搜尋' }
        },
        message: {
          'no-result': '搜尋不到符合關鍵字的結果'
        }
      }
    },
    detail: {
      title: '佛像介紹',
      list: {
        efile: {
          heading: '佛像電子檔'
        }
      },
      button: {
        'view-more': { label: '瀏覽更多佛像佛卡' }
      }
    },
    'efile-list': {
      title: '佛像電子檔',
      label: {
        downloadable: '圖檔',
        printable: '印刷檔'
      },
      message: {
        'no-efile': '無電子檔可下載'
      }
    },
    button: {
      introduction: { label: '簡介' },
      application: {
        label: {
          'in-stock': '佛像申請',
          'out-of-stock': '無庫存'
        }
      },
      download: { label: '電子檔下載' }
    }
  },

  dharma: {
    title: '法寶申請',
    list: {
      latest: {
        title: '最新法寶',
        button: {
          introduction: { label: '簡介' }
        }
      },
      application: {
        title: '法寶申請',
        link: {
          'master-list-download': '總表下載'
        }
      },
      download: { title: '法寶下載' },
      book: {
        title: '經書',
        label: {
          'selected-language': '目前選擇'
        }
      },
      picture: { title: '佛像佛卡' },
      search: {
        title: '法寶搜尋',
        'type-selector': {
          label: '查詢類型',
          option: {
            book: { label: '經書' },
            picture: { label: '佛像或佛卡' }
          }
        },
        'keyword-inputor': { hint: '請輸入關鍵字' },
        button: {
          search: { label: '搜尋' }
        },
        message: {
          'no-result': '搜尋不到符合關鍵字的結果'
        }
      },
      modal: {
        'next-page-notice': {
          title: '提示',
          message: '有更多頁面，請繼續瀏覽'
        }
      }
    },
    detail: {
      title: '經書法寶介紹'
    }
  },

  'buddhist-dictionary': {
    title: '佛學辭典工具'
  },

  animation: {
    title: '佛陀教育動畫集成'
  },

  compassion: {
    title: '護生環保',
  },

  'life-caring-article': '護生文集',
  'life-caring-monthly-calendar': '護生月曆',
  'life-caring-picture': '護生圖畫',

  search: {
    title: '資料搜尋',
    'type-selector': {
      label: '查詢類型',
      option: {
        book: { label: '經書' },
        picture: { label: '佛像或佛卡' },
        series: { label: '影音講題' },
        lendable_book: { label: '圖書館藏書目查詢' }
      }
    },
    'category-selector': {
      label: '分類搜尋',
      button: {
        clear: { label: '清除' }
      }
    },
    'keyword-inputor': { hint: '請輸入關鍵字' },
    button: {
      search: { label: '搜尋' }
    },
    message: {
      'no-result': '搜尋不到符合關鍵字的結果'
    }
  },

  partner: '網站連結',

  amtb: {
    title: '淨宗學會'
  },

  'other-website': {
    title: '其他網站連結',
    list: {
      'traditional-chinese': {
        title: '正體中文網站'
      },
      'simplified-chinese': {
        title: '簡體中文網站'
      }
    }
  },

  lang: '選擇語言...',

  'book-language-selector-button': {
    label: '選擇語系',
    modal: {
      'book-language-selector': {
        title: '選擇語系'
      }
    }
  },

  'series-category-selector-button': {
    label: '選擇分類',
    modal: {
      'series-category-selector': {
        title: '選擇分類'
      }
    }
  },

  'social-sharing-button-toolbar': {
    label: {
      share: '分享'
    }
  },

  'application-list-button-toolbar': {
    button: {
      display: { label: '申請清單' },
      send: { label: '送出' }
    },
    modal: {
      'application-list-confirm-send-message': {
        title: '確認送出',
        content: '送出前請再次確認申請清單是否正確！',
        button: {
          yes: { label: '是' },
          no: { label: '否' }
        }
      }
    }
  },

  'audiovisual-player': {
    audio: { title: '音訊檔' },
    video: { title: '影片檔' },
    message: {
      'unsupported-format': [
        '本講題的影音內容目前不提供線上播放，',
        '請自行下載檔案播放觀看。'
      ]
    }
  },

  'size-cm-conversion-table': {
    title: '開數對照表',
    table: {
      header: {
        format: '開數',
        centimeter: '公分'
      }
    }
  },

  'weekly-subscription-form': {
    title: '訂閱 / 退訂電子報',
    label: {
      email: '電子郵件',
      'subscribe-or-unsubscribe': '請問您想要：'
    },
    'subscribe-or-unsubscribe-radio-button': {
      option: {
        subscribe: { label: '訂閱電子報' },
        unsubscribe: { label: '退訂電子報' }
      }
    },
    message: {
      'subscription-completed': '您已完成訂閱',
      'unsubscription-completed': '您已完成退訂',
    }
  },

  'dharma-application-form': {
    title: '法寶申請',
    'application-summary': {
      'instruction-text': {
        'check-and-confirm': '這是確認頁面，請仔細檢查您的申請內容。若有錯誤可直接修改，確定無誤後再送出。',
        'change-application-items': '若需變更申請項目，需放棄申請重新填寫。',
        'china-mainland-application-notice': '寄往大陸地區，請務必填寫與證件相符的真實姓名，以避免無法收件。<br><br>※因經書法寶寄送大陸內地，須受嚴格管制檢查，運送時程約需60天至90天以上，煩請耐心等候，造成不便，敬請見諒！由於申請者眾多，申請完成後60天內，敬祈勿來函催促詢問進度，避免影響寄贈作業，非常感謝您的包涵諒解，謹致謝意！<br>※申請經書法寶，煩請詳細瀏覽結緣書目，於選定書目，確認無誤後，敬請一次申請完成，將申請書目集中於一張表單！切勿分成多次申請，以避免遺漏申請表單、重複拆裝包裹之困擾，嚴重影響寄贈作業流程！非常感謝您的配合協助，謹致謝意！'
      },
      modal: {
        'china-mainland-application-notice': {
          title: '大陸地區申請須知',
          button: {
            ok: { label: '我已確認' }
          }
        }
      },
      button: {
        'give-up': { label: '放棄申請' }
      }
    },
    'application-list': {
      title: '申請清單',
      label: {
        quantity: '數量',
        purpose: '申請經書法寶的用途或理由',
        purpose_detail: '用途詳細說明'
      },
      badge: {
        'in-stock': '有庫存',
        'out-of-stock': '無庫存',
        'advanced-book': '進階書',
        'scroll-picture': '捲軸佛像'
      },
      'instruction-text': {
        purpose: '當您的申請符合以下任一條件時，須簡要說明申請經書法寶的用途或理由，以供本會作為寄贈參考：<ul style="padding-left: 2em"><li style="list-style-type:disc">書籍總數超過五冊/套。</li><li style="list-style-type:disc">進階書數量達一冊/套 (含) 以上。</li><li style="list-style-type:disc">捲軸佛像數量達一幅 (含) 以上。</li></ul>',
        purpose_detail: '若申請數量超過 50 冊，請提供更詳細的用途說明'
      },
      'error-message': {
        items: {
          required: '請先將項目加入申請清單再送出申請',
          'quantity-not-less-than-one': '申請數量不能小於 1',
          'item-out-of-stock': '申請項目包含無庫存而無法申請的項目，請將該項目移除才能送出申請'
        },
        purpose: {
          required: '申請經書法寶的用途或理由未填寫'
        },
        purpose_detail: {
          required: '用途詳細說明未填寫'
        }
      },
      button: {
        remove: { label: '移除' }
      }
    },
    applicant: {
      title: '申請人資料',
      'type-selector': {
        label: '請問您是：',
        hint: '請先選擇申請類型',
        option: {
          individual: { label: '個人申請' },
          group: { label: '團體申請' },
          proxy: { label: '代其他團體申請' }
        }
      },
      'error-message': {
        type: { required: '申請類型未選擇' }
      },
      delivery: {
        title: '寄送資訊',
        label: {
          area: '寄送地區',
          'customs-duty-option': '請選擇關稅負擔方式',
          'shipping-cost-option': '請選擇運費負擔方式',
          'shipping-cost-option-description': '請說明事由',
          object: '收件方式',
          'postal-code': '郵遞區號',
          address: '寄送地址：',
          city: '城市',
          district: '地區',
          'street-address': '街道地址',
          'cvs-code': '超商取件門市代號(僅限全家便利商店)',
          'nearest-available-port': '最近港口',
          'can-clear-customs': '請確保貴寺/機構能夠順利通關並從港口海關當局領取所有佛經書籍！'
        },
        'area-selector': { hint: '請選擇寄送地區' },
        'customs-duty-option-selector': { hint: '請選擇關稅負擔方式' },
        'shipping-cost-option-selector': { hint: '請選擇運費負擔方式' },
        'object-selector': {
          hint: '請選擇收件方式',
          option: {
            applicant: '送貨到府',
            agent: '代申請人取件',
            principal: '原委託團體取件',
            cvs: '便利超商取件(僅限全家便利商店)'
          }
        },
        button: {
          'cvs-code-inquiry': { label: '超商門市代號查詢' },
          'cvs-code-pickup-service-instructions': { label: '便利商店取件服務說明' }
        },
        'help-text': {
          address: '寄送地址各欄位，僅有寄往台灣、大陸地區、香港、澳門或日本可選用中文填寫，其餘海外地區請用英文填寫，以利本會寄件。'
        },
        'instruction-text': {
          'shipping-cost-option-description': '您選擇「無法負擔運費等」，請說明事由，以供本會作為寄贈參考。',
          'customs-duty-option': '注意：<br>如果我們透過貨櫃運送大量佛經，您是否願意向您所在國家的港口海關當局和貨運代理支付約 500 ~ 1000 美元的當地稅費和其他雜費？'
        },
        'disclaimer-text': {
          'customs-duty-option': {
            'unable-to-pay': '注意：<br>在一些國家，例如印度、斯里蘭卡、越南等...，<br>郵局將會要求您繳納關稅，關稅的範圍取決於包裹的重量;<br>一個小包可能需要您支付 1 ～ 20 美元或以上，視您所在國家的郵寄規則而定。<br>如果您無法繳納關稅，佛經書籍將被退回給我們，<br>因此我們很遺憾，只能寄送少量 (大約 1-3 冊) 的佛經書籍給您。'
          },
          'can_clear_customs': {
            no: '注意：<br>如果您無法從目的地港口海關當局領取所有佛經書籍，我們很遺憾，只能寄送少量佛經書籍給您。'
          }
        },
        'reminder-text': {
          city: {
            'can-apply-at-the-counter': '提醒您，寄送到臺北地區的申請者，可親臨本會櫃檯辦理申請，節省運費。'
          }
        },
        'error-message': {
          object: { required: '收件方式未選擇' },
          area: { required: '寄送地區未選擇' },
          'postal-code': { required: '郵遞區號未填寫' },
          city: {
            required: '城市未填寫',
            'some-areas-support-chinese-input': '城市欄僅有寄往台灣、大陸地區、香港、澳門或日本可選用中文填寫，其餘海外地區請用英文填寫'
          },
          district: {
            required: '地區未填寫',
            'some-areas-support-chinese-input': '地區欄僅有寄往台灣、大陸地區、香港、澳門或日本可選用中文填寫，其餘海外地區請用英文填寫'
          },
          'street-address': {
            required: '街道地址未填寫',
            'some-areas-support-chinese-input': '街道地址欄僅有寄往台灣、大陸地區、香港、澳門或日本可選用中文填寫，其餘海外地區請用英文填寫'
          },
          'cvs-code': { required: '超商取件門市代號未填寫' },
          'customs-duty-option': { required: '關稅負擔方式未選擇' },
          'shipping-cost-option': { required: '運費負擔方式未選擇' },
          'shipping-cost-option-description': { required: '運費負擔方式的說明事由未填寫' },
          'nearest-available-port': { required: '最近港口未填寫' },
          'can-clear-customs': { required: '請確保貴寺/機構能夠順利通關並從港口海關當局領取所有佛經書籍。' }
        },
        option: {
          yes: '是',
          no: '否'
        }
      },
      contact: {
        title: '聯絡方式',
        individual: {
          label: {
            name: '姓名',
            'group-name': '所屬團體或單位',
            email: '電子郵件',
            phone: '電話',
            'mobile-phone': '手機',
            tin: '稅務識別碼',
            fax: '傳真',
            gmail: 'Gmail',
            'official-email': '官方電子郵件'
          },
          'error-message': {
            name: {
              required: '姓名未填寫',
              'some-areas-support-chinese-input': '姓名欄僅有寄往台灣、大陸地區、香港、澳門或日本可選用中文填寫，其餘海外地區請用英文填寫'
            },
            'group-name': {
              required: '所屬團體或單位未填寫',
              'some-areas-support-chinese-input': '所屬團體或單位欄僅有寄往台灣、大陸地區、香港、澳門或日本可選用中文填寫，其餘海外地區請用英文填寫'
            },
            email: {
              required: '電子郵件未填寫',
              invalid: '電子郵件格式不正確'
            },
            phone: { required: '電話號碼未填寫' },
            'mobile-phone': { required: '手機號碼未填寫' },
            tin: {
              required: '稅務識別碼未填寫',
              invalid: '稅務識別碼格式不正確'
            },
            fax: { required: '傳真未填寫' },
            gmail: { required: 'Gmail 未填寫' },
            'official-email': {
              required: '官方電子郵件未填寫',
              invalid: '官方電子郵件格式不正確'
            }
          }
        },
        group: {
          label: {
            'group-name': '團體或單位名稱',
            name: '聯絡人姓名',
            email: '聯絡人電子郵件',
            phone: '聯絡人電話',
            'mobile-phone': '聯絡人手機',
            tin: '稅務識別碼',
            fax: '傳真',
            gmail: 'Gmail',
            'official-email': '官方電子郵件'
          },
          'error-message': {
            'group-name': {
              required: '團體或單位名稱未填寫',
              'some-areas-support-chinese-input': '團體或單位名稱欄僅有寄往台灣、大陸地區、香港、澳門或日本可選用中文填寫，其餘海外地區請用英文填寫'
            },
            name: {
              required: '聯絡人姓名未填寫',
              'some-areas-support-chinese-input': '聯絡人姓名欄僅有寄往台灣、大陸地區、香港、澳門或日本可選用中文填寫，其餘海外地區請用英文填寫'
            },
            email: {
              required: '聯絡人電子郵件未填寫',
              invalid: '聯絡人電子郵件格式不正確'
            },
            phone: { required: '聯絡人電話未填寫' },
            'mobile-phone': { required: '聯絡人手機未填寫' },
            tin: {
              required: '稅務識別碼未填寫',
              invalid: '稅務識別碼格式不正確'
            },
            fax: { required: '傳真未填寫' },
            gmail: { required: 'Gmail 未填寫' },
            'official-email': {
              required: '官方電子郵件未填寫',
              invalid: '官方電子郵件格式不正確'
            }
          }
        },
        agent: {
          title: '代申請人',
          label: {
            name: '姓名',
            'group-name': '所屬團體或單位',
            email: '電子郵件',
            phone: '電話',
            'mobile-phone': '手機',
            tin: '稅務識別碼',
            fax: '傳真',
            gmail: 'Gmail',
            'official-email': '官方電子郵件'
          },
          'error-message': {
            name: {
              required: '姓名未填寫',
              'some-areas-support-chinese-input': '姓名欄僅有寄往台灣、大陸地區、香港、澳門或日本可選用中文填寫，其餘海外地區請用英文填寫'
            },
            'group-name': {
              required: '所屬團體或單位未填寫',
              'some-areas-support-chinese-input': '所屬團體或單位欄僅有寄往台灣、大陸地區、香港、澳門或日本可選用中文填寫，其餘海外地區請用英文填寫'
            },
            email: {
              required: '電子郵件未填寫',
              invalid: '電子郵件格式不正確'
            },
            phone: { required: '電話號碼未填寫' },
            'mobile-phone': { required: '手機號碼未填寫' },
            tin: {
              required: '稅務識別碼未填寫',
              invalid: '稅務識別碼格式不正確'
            },
            fax: { required: '傳真未填寫' },
            gmail: { required: 'Gmail 未填寫' },
            'official-email': {
              required: '官方電子郵件未填寫',
              invalid: '官方電子郵件格式不正確'
            }
          }
        },
        principal: {
          title: '原委託團體',
          label: {
            'group-name': '團體或單位名稱',
            name: '聯絡人姓名',
            email: '聯絡人電子郵件',
            phone: '聯絡人電話',
            'mobile-phone': '聯絡人手機',
            fax: '傳真',
            gmail: 'Gmail',
            'official-email': '官方電子郵件'
          },
          'error-message': {
            'group-name': {
              required: '團體或單位名稱未填寫',
              'some-areas-support-chinese-input': '團體或單位名稱欄僅有寄往台灣、大陸地區、香港、澳門或日本可選用中文填寫，其餘海外地區請用英文填寫'
            },
            name: {
              required: '聯絡人姓名未填寫',
              'some-areas-support-chinese-input': '聯絡人姓名欄僅有寄往台灣、大陸地區、香港、澳門或日本可選用中文填寫，其餘海外地區請用英文填寫'
            },
            email: {
              required: '聯絡人電子郵件未填寫',
              invalid: '聯絡人電子郵件格式不正確'
            },
            phone: { required: '聯絡人電話未填寫' },
            'mobile-phone': { required: '聯絡人手機未填寫' },
            fax: { required: '傳真未填寫' },
            gmail: { required: 'Gmail 未填寫' },
            'official-email': {
              required: '官方電子郵件未填寫',
              invalid: '官方電子郵件格式不正確'
            }
          }
        },
        'help-text': {
          name: {
            'fill-in-chinese-or-english': '僅有寄往台灣、大陸地區、香港、澳門或日本可選用中文填寫，其餘海外地區請用英文填寫，以利本會寄件。',
            'fill-in-the-real-name': '寄往大陸地區，請務必填寫與證件相符的真實姓名，以避免無法收件。'
          },
          'group-name': {
            'fill-in-chinese-or-english': '僅有寄往台灣、大陸地區、香港、澳門或日本可選用中文填寫，其餘海外地區請用英文填寫，以利本會寄件。'
          },
          tin: {
            'need-to-fill-in-for-small-quantity-applications': '由於寄送地區是巴西，發往該國之各類國際商品類郵件上應載明收件人TAX ID。',
            'need-to-fill-in-for-large-quantity-applications': '由於寄送地區是巴西、印度、不丹、尼泊爾、印尼，發往該國之各類國際商品類郵件上應載明收件人TAX ID。'
          },
          'strictly-prohibited-for-sale': '*法寶僅限個人研修使用.嚴禁販售*'
        }
      },
      tax: {
        title: '稅務資訊',
        label: {
          tin: '稅務識別碼',
          pan: '永久帳戶號碼 (PAN)',
          gstin: '商品及服務稅識別號 (GSTIN)',
          iec: '進出口代碼 (IEC)'
        },
        'error-message': {
          tin: {
            required: '稅務識別碼未填寫',
            invalid: '稅務識別碼格式不正確'
          },
          pan: { required: '永久帳戶號碼 (PAN) 未填寫' },
          gstin: { required: '商品及服務稅識別號 (GSTIN) 未填寫' },
          iec: { required: '進出口代碼 (IEC) 未填寫' }
        },
        'help-text': {
          tin: {
            'need-to-fill-in': '由於寄送地區是巴西、印度、不丹、尼泊爾、印尼，發往該國之各類國際商品類郵件上應載明收件人TAX ID。'
          }
        }
      }
    },
    message: {
      'already-added-to-application-list': '已加入申請清單',
      'application-completed': {
        title: '申請完成',
        content: [
          '您已完成申請',
          '確認信函將於稍後寄到您所填寫的電子郵件位址，若一天後仍未收到，請聯絡以下資訊：',
          '電子郵件：',
          '電話：',
          '轉分機'
        ]
      },
      'application-notice': {
        title: '申請注意事項',
        content: [
          [
            '依據您提出的申請內容，我們會以庫存現況盡力為您寄贈佛書及法寶。',
            '由於我們的資源有限，為了能公平且永續地讓更多人受益於免費的法寶服務，我們懇請您避免申請超出您需求的數量。',
            '為提高處理效率，請將您的所有需求集中在單一申請中，而非拆分為多個申請。對於重複的申請，我們將無法處理，敬請見諒。'
          ],
          [
            '由於申請數量龐大，您可能需要等待三個月以上才能收到法寶。',
            '為加速寄送流程，懇請您耐心等候，並在收到法寶前避免寄送追蹤郵件。',
            '請注意，我們所有的法寶皆為免費結緣，在任何情況下均不得販售。'
          ]
        ]
      },
      'application-list-confirm-submit': {
        title: '確認送出',
        content: '送出前請再次確認申請清單是否正確！',
        button: {
          yes: { label: '是' },
          no: { label: '否' }
        }
      },
      'application-list-confirm-send': {
        title: '確認送出',
        content: '送出前請再次確認申請清單是否正確！',
        button: {
          yes: { label: '是' },
          no: { label: '否' }
        }
      }
    }
  },

  'college-registration-form': {
    title: '佛學院報名表',
    basic: {
      title: '基本資料',
      label: {
        name: '姓名',
        'birth-date': '出生日期',
        gender: '性別',
        phone: '電話',
        'mobile-phone': '手機',
        email: '電子郵件',
        'line-id': 'Line ID',
        address: '通訊地址',
        education: '最高學歷',
        organization: '服務單位'
      },
      'gender-selector': { hint: '請選擇性別' },
      'education-selector': { hint: '請選擇最高學歷' },
      'instruction-text': {
        'phone-required': '「電話」與「手機」請至少填寫一項'
      }
    },
    study: {
      title: '選擇課程',
      label: {
        'primary-department': '主修課程',
        'other-departments': '他宗課程（可多選）',
        'buddhist-background': '學佛經歷',
        'studied-sutras': '曾學經論',
        'favorite-sutras': '最受用經論',
        expectations: '對本學院之期待'
      },
      option: {
        gender: {
          male: '男',
          female: '女'
        }
      },
      'notice-message': {
        'exclusive-limit': '所選班別為{department}，不可加選他宗課程',
        'limit-reached': '最多可選 3 個班別，已達上限'
      }
    },
    confirm: {
      title: '確認報名',
      content: '送出前請再次確認報名資料是否正確！',
      button: {
        yes: { label: '是' },
        no: { label: '否' }
      }
    },
    success: {
      title: '報名成功',
      message: '您的報名資料已成功送出，系統將會寄送報名確認信至您的電子郵件信箱。我們會儘快處理您的申請。',
    },
    button: {
      'prev-step': { label: '上一步' },
      'next-step': { label: '下一步' },
      submit: { label: '送出報名' },
    }
  },

  'event-registration-form': {
    title: '活動報名表',
    basic: {
      title: '基本資料',
      label: {
        name: '姓名',
        gender: '性別',
        'birth-date': '出生日期',
        education: '教育程度',
        occupation: '職業',
        'health-condition': '健康狀況',
        email: '電子信箱',
        phone: '電話',
        'mobile-phone': '手機',
        address: '通訊地址',
        'emergency-contact-name': '聯絡人姓名',
        'emergency-contact-phone': '聯絡人電話',
        'emergency-contact-mobile-phone': '聯絡人手機',
        'emergency-contact-address': '聯絡人地址'
      },
      heading: {
        contact: '聯絡資訊',
        'emergency-contact': '緊急聯絡人'
      },
      placeholder: {
        'please-specify': '請說明',
      },
      'instruction-text': {
        'phone-required': '「電話」與「手機」請至少填寫一項'
      }
    },
    detail: {
      title: '詳細資料',
      heading: {
        'transportation': '交通方式',
      },
      label: {
        precepts: '受戒狀況',
        'full-ordination-date': '受戒日期',
        'observing-eight-precepts': '是否受過八關齋戒',
        skills: '專長',
        'volunteer-interest': '有意願擔任義工',
        'volunteer-or-staff-role': '曾任人員或志工職務',
        'how-heard': '消息來源',
        'attended-times': '參加次數',
        'transportation-go': '去程',
        'transportation-return': '回程',
        remarks: '備註',
        agreement: '承諾',
      },
      placeholder: {
        'please-specify': '請說明',
        'full-ordination-date': '請選擇日期'
      },
      'declaration-text': {
        agreement: '本人願意在活動期間，遵守所有規定，服從領眾法師及常住之指導，不破壞活動秩序，不影響大眾。若有違者，願遵照活動規約處理，因果自負。'
      },
      option: {
        precepts: {
          'bodhisattva_none': '未受菩薩戒',
          'bodhisattva_history': '曾經受過',
          'bodhisattva_times': '次菩薩戒',
        },
        agreement: {
          agree: '我同意',
          disagree: '我不同意'
        }
      }
    },
    confirm: {
      title: '確認送出',
      content: '送出前請再次確認報名資料是否正確！',
      button: {
        yes: { label: '是' },
        no: { label: '否' }
      }
    },
    success: {
      title: '報名成功',
      message: '您的報名資料已成功送出，系統將會寄送報名確認信至您的電子郵件信箱。我們會儘快處理您的申請。'
    },
    button: {
      'prev-step': { label: '上一步' },
      'next-step': { label: '下一步' },
      submit: { label: '送出報名' },
    },
    
    'photo': '照片上傳',
    'photo_hint': '請上傳個人近照 (支援 jpg, png 格式)'
  },

  modal: {
    button: {
      'continue-browsing': { label: '繼續瀏覽' },
      'close': { label: '關閉' },
      'cancel': { label: '取消' },
      'submit': { label: '送出' },
      'submitting': { label: '正在送出...' },
      'complete': { label: '完成' },
      'ok': { label: '確定' }
    }
  },

  paginator: {
    'items-per-page-selector': {
      option: { label: '每頁 {size} 筆' }
    }
  },

  issue: '第 {issue} 期',

  frequency: {
    weekly: '每週',
    'weeks-of-month': {
      first: '每月第一週',
      second: '每月第二週',
      third: '每月第三週',
      fourth: '每月第四週',
      fifth: '每月第五週'
    },
    'week-intervals': {
      one: '隔週',
      two: '隔二週',
      three: '隔三週',
      four: '隔四週',
      five: '隔五週'
    }
  },

  'days-of-week': {
    sunday: { full: '星期日', abbr: '日' },
    monday: { full: '星期一', abbr: '一' },
    tuesday: { full: '星期二', abbr: '二' },
    wednesday: { full: '星期三', abbr: '三' },
    thursday: { full: '星期四', abbr: '四' },
    friday: { full: '星期五', abbr: '五' },
    saturday: { full: '星期六', abbr: '六' }
  }
}

